import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AlertSeeker } from "@ui-seeker/core"

import { country, retailer } from "@signals"


export default function CatalogueAnalyzerMainSiteWarning() {
	const isOpen = useSignal(true)

    if (country.value?.length || retailer.value?.length)
         return <></>

	return <Box sx={{ width: 1 }}>
		<AlertSeeker
			isOpen={isOpen.value}
			severity="warning"
			controller={() => isOpen.value = !isOpen.value}
			title="Warning Filters"
			open={true}
		>
			If no country or retailer is specified, only main sites will be included in the search results.
		</AlertSeeker>
	</Box>  
}